// extracted by mini-css-extract-plugin
module.exports = {"contents":"Contents-module--contents--2tQQ6","section":"Contents-module--section--1CDm-"};